module.exports = __webpack_public_path__ + "img/alloy.6684be96.png";